var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("management-notice", {
        attrs: {
          title:
            "用于标识店铺所属商圈，主要用于移动端的商圈切换，最多支持三级结构，如“陕西/西安/雁塔区”",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "acea-row row-middle" },
            [
              _vm.hasCirclePermi("save")
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleAdd()
                        },
                      },
                    },
                    [_vm._v("新增店铺分组")]
                  )
                : _vm._e(),
              _vm.hasCirclePermi("conjunctive:diy")
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        disabled: !_vm.checkedIds.length,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleAssociation()
                        },
                      },
                    },
                    [_vm._v("批量关联微页面")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                size: "small",
                "row-key": "id",
                "tree-props": {
                  children: "childList",
                  hasChildren: "hasChildren",
                },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _vm.hasCirclePermi("conjunctive:diy")
                ? _c("el-table-column", {
                    key: "2",
                    attrs: { type: "selection", width: "55" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "ID",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "店铺分组名称",
                  "min-width": "200",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "range",
                  label: "店铺范围",
                  "min-width": "200",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.range || "-"))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantCount",
                  label: "店铺数量",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.merchantCount || 0)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "diyName",
                  label: "关联微页面",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "店铺分组状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.hasCirclePermi("status")
                          ? _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "active-text": "启用",
                                "inactive-text": "禁用",
                                "inactive-value": false,
                                size: "mini",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onchangeIsShow(scope.row, "status")
                                },
                              },
                              model: {
                                value: scope.row.status,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "status", $$v)
                                },
                                expression: "scope.row.status",
                              },
                            })
                          : _c("span", [
                              _vm._v(
                                _vm._s(scope.row.status ? "启用" : "禁用")
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "是否显示", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.hasCirclePermi("show")
                          ? _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "active-text": "显示",
                                "inactive-text": "隐藏",
                                "inactive-value": false,
                                size: "mini",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onchangeIsShow(scope.row, "show")
                                },
                              },
                              model: {
                                value: scope.row.isShow,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "isShow", $$v)
                                },
                                expression: "scope.row.isShow",
                              },
                            })
                          : _c("span", [
                              _vm._v(
                                _vm._s(scope.row.isShow ? "显示" : "隐藏")
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.level < 3
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.hasCirclePermi("save"),
                                    expression: "hasCirclePermi('save')",
                                  },
                                ],
                                attrs: {
                                  disabled:
                                    scope.row.level == scope.row.chainLength,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAdd(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("新增下级")]
                            )
                          : _vm._e(),
                        scope.row.level < 3 &&
                        _vm.hasCirclePermi("save") &&
                        (_vm.hasCirclePermi("info") ||
                          _vm.hasCirclePermi("update"))
                          ? _c("el-divider", {
                              attrs: { direction: "vertical" },
                            })
                          : _vm._e(),
                        _vm.hasCirclePermi("info") ||
                        _vm.hasCirclePermi("update")
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView(scope.row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            )
                          : _vm._e(),
                        (_vm.hasCirclePermi("info") ||
                          _vm.hasCirclePermi("update")) &&
                        _vm.canManageCircleMore()
                          ? _c("el-divider", {
                              attrs: { direction: "vertical" },
                            })
                          : _vm._e(),
                        _vm.canManageCircleMore()
                          ? _c(
                              "el-dropdown",
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link" },
                                  [
                                    _vm._v("更多"),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right",
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _vm.hasCirclePermi("update")
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              disabled: scope.row.status,
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleEdit(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("编辑")]
                                        )
                                      : _vm._e(),
                                    _vm.hasCirclePermi("bind")
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleBindMerchant(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("关联店铺")]
                                        )
                                      : _vm._e(),
                                    _vm.hasCirclePermi("conjunctive:diy")
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleAssociation(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("关联微页面")]
                                        )
                                      : _vm._e(),
                                    _vm.hasCirclePermi("delete")
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("template-dialog", {
        attrs: { AssociationDia: _vm.AssociationDia },
        on: { handleClose: _vm.handleClose, changeList: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }